import { render } from "./ListadoCausacion.vue?vue&type=template&id=4b3485f0&scoped=true"
import script from "./ListadoCausacion.vue?vue&type=script&lang=js"
export * from "./ListadoCausacion.vue?vue&type=script&lang=js"

import "./ListadoCausacion.vue?vue&type=style&index=0&id=4b3485f0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b3485f0"]])

export default __exports__